import { defineMessages } from 'react-intl'

const messages = defineMessages({
  reservationNotOk: {
    id: 'global.new-reservation-notok',
  },
  reservationNextStep: {
    id: 'global.new-reservation-next-step',
  },
  changeDatesNotOk: {
    id: 'global.change-dates-notok',
  },
  dontWorry: {
    id: 'global.change-dates-send-cs',
  },
  book: {
    id: 'global.book',
  },
})

export default messages
